<template>
  <b-modal
    id="breeze-modal"
    v-model="show"
    centered
    modal-class="ds-modal"
    @hide="$emit('input', false)"
  >
    <template
      v-if="title !== ''"
      #modal-title
    >
      {{ title }}
    </template>
    <slot />

    <template #modal-footer>
      <ds-button @click="$emit('ok')">
        {{ okButton }}
      </ds-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { DsButton } from '@/design-system/components'

export default {
  name: 'BreezeModal',
  components: {
    BModal,
    DsButton,
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '',
    },
    okButton: {
      type: String,
      default: 'Ok',
    },
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    value() {
      this.show = this.value
    },
  },
  created() {
    this.show = this.value
  },
}
</script>
